<button
  #toggleMenuDirective="toggleMenuDirective"
  aria-label="Toggle menu"
  nodaMenuToggle
  class="btn"
>
  <svg-icon
    class="icon"
    [name]="
      toggleMenuDirective.isActive ? 'controls/close.svg#close' : 'controls/burger.svg#burger'
    "
    [size]="19"
  />
</button>
